import React from 'react';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from '../lib/trackWhatsApp';

const WhatsAppButton = () => {
  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    trackWhatsAppClick({ openInNewTab: true, location: 'floating' });
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="whatsapp-icon" />
      <span className="whatsapp-label">WhatsApp</span>
    </button>
  );
};

export default WhatsAppButton;
